// import React from 'react';

// export default function DashboardCard({ title, value, bgColor, onClick }) {
//   return (
//     <div
//       className={`cursor-pointer p-6 rounded shadow text-white ${bgColor} flex flex-col justify-center items-center`}
//       onClick={onClick}
//       role="button"
//       tabIndex={0}
//       onKeyPress={(e) => {
//         if (e.key === 'Enter' || e.key === ' ') onClick();
//       }}
//     >
//       <h3 className="text-lg font-semibold">{title}</h3>
//       <p className="text-3xl font-bold">{value}</p>
//     </div>
//   );
// }


// import React from 'react';

// export default function DashboardCard({ title, value, bgColor, onClick }) {
//   return (
//     <div
//       className={`cursor-pointer p-6 rounded shadow text-white ${bgColor} flex flex-col justify-center items-center`}
//       onClick={onClick}
//       role="button"
//       tabIndex={0}
//       onKeyPress={(e) => {
//         if (e.key === 'Enter' || e.key === ' ') onClick();
//       }}
//     >
//       <h3 className="text-lg font-semibold">{title}</h3>
//       <p className="text-3xl font-bold">{value}</p>
//     </div>
//   );
// }


import React from "react";

const getIcon = (title) => {
  const icons = {
    "QC Finished": "🏆",
    "Waiting For QC": "⏳",
    "GRN Pending": "📋",
    "Total GRN": "📦",
    "Pending QC": "🔄",
    "QC Completed": "🎯",
    "Rejected": "❌",
  };
  return icons[title] || "📊";
};

export default function DashboardCard({ title, value, bgColor, onClick }) {
  return (
    <div
      className={`cursor-pointer p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-102 ${bgColor} text-white relative overflow-hidden border-2 border-white/20`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      {/* Background Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 flex items-start space-x-4">
        {/* Icon */}
        <div className="text-5xl flex-shrink-0">
          {getIcon(title)}
        </div>

        {/* Text Content */}
        <div className="flex-1 min-w-0">
          {title && (
            <h3 className="text-xl font-bold mb-3 uppercase tracking-wide">{title}</h3>
          )}
          <div className="text-lg font-medium leading-relaxed">{value}</div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-4 right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute bottom-4 left-4 w-8 h-8 bg-white/5 rounded-full"></div>
    </div>
  );
}

